'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DragType = exports.DragType = {
  CARD: 'card'
};


//////////////////
// WEBPACK FOOTER
// ./~/react-trello/dist/helpers/DragType.js
// module id = 1127
// module chunks = 0